// @ts-nocheck
import React, { memo } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const TemplateVersionOption = memo(
  ({ versionNumber, isDefaultVersion = false }) => {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography variant="h5">
          {versionNumber || 'Select all options'}
        </Typography>
        {isDefaultVersion ? (
          <Chip
            label="Active"
            size="small"
            className="sm-chip"
            title="Default Version"
            color="primary"
          />
        ) : null}
      </Box>
    );
  }
);

TemplateVersionOption.propTypes = {
  versionNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isDefaultVersion: PropTypes.bool,
};

const renderTemplateVersionOption = (props, option) => {
  return (
    <li {...props}>
      <TemplateVersionOption
        versionNumber={option?.version_number}
        isDefaultVersion={option?.is_default}
      />
    </li>
  );
};

export default renderTemplateVersionOption;
